/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Assignee from './Assignee/index'
import Board from './Board/index'
import Description from './Description/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import Title from './Title/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 weight="medium"
 text="Details"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 textTransform="uppercase"
 marginBottom={dtSpaceLs}
 text="Add task to"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Board
  viewPath={`${viewPath}/Board`}
/>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 textTransform="uppercase"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceLs}
 text="Other details"
/>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
</div>
</div>
<div
  data-testid="Content.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceL}
 text="Tags"
/>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}